import { connect, useDispatch, ConnectedProps } from 'react-redux';
import { PARAMETERS } from '@root/tracking/constants';
import routes from '@root/routes';
import { Landlord } from '@root/types';
import {
  galleryNavigated,
  landlordThumbnailClicked,
  savedBuildingOwnerNotificationLinkClicked,
} from '@store/actions/landlordPage';
import Portfolio from './Portfolio';
import Layout from '../Layout';
import LandlordHeaderSection from './LandlordHeaderSection';
import RawImages from '../Building/Images/RawImages';
import LandlordHead from './LandlordHead';
import s from './Landlord.module.less';
import { LandlordDescriptionExecutive } from './LandlordDescriptionExecutive';

const mapDispatch = {
  savedBuilingOwnerLinkClicked: () => savedBuildingOwnerNotificationLinkClicked,
};

const connector = connect(null, mapDispatch);
type PassedProps = {
  landlord: Landlord;
  hasLoadedOnce: boolean;
  isPreview?: boolean;
};
type ReduxProps = ConnectedProps<typeof connector>;

export const LandlordLayout = ({
  savedBuilingOwnerLinkClicked,
  hasLoadedOnce,
  landlord,
  isPreview = false,
}: ReduxProps & PassedProps) => {
  const dispatch = useDispatch();

  return (
    <Layout showFooter={!!landlord}>
      <LandlordHead landlord={landlord} isPreview={isPreview} />
      <LandlordHeaderSection
        landlord={landlord}
        savedBuilingOwnerLinkClicked={savedBuilingOwnerLinkClicked}
        hasLoadedOnce={hasLoadedOnce}
      />
      <div className={s.mediaAssets}>
        <RawImages
          photos={landlord.photos}
          video={landlord.video}
          lightboxPaginationClicked={() => dispatch(galleryNavigated)}
          lightboxThumbnailClicked={() => dispatch(landlordThumbnailClicked)}
          sourcePage={PARAMETERS.landlordPage}
          sourceContent={PARAMETERS.brandGallery}
          firstPhotoOrientation={landlord.firstPhotoOrientation}
          imagesZipUrl={routes.api.landlordImagesZipUrl(landlord.slug)}
          companyName={landlord.name}
        />
      </div>

      <LandlordDescriptionExecutive landlord={landlord} />

      <Portfolio
        landlordSlug={landlord.slug}
        landlordId={landlord.id}
        isPreview={isPreview}
        marketSlugs={landlord.marketSlugs}
      />
    </Layout>
  );
};

export default connector(LandlordLayout);
